/** Root element PrimeNG renders for every dialog (DynamicDialog, p-dialog, confirm dialog). */
export const DIALOG_SELECTOR = '.p-dialog';

/** The open dialog with the highest z-index; later in DOM order wins a tie. */
export function topmostDialog(document: Document): Element | null {
  let topmost: Element | null = null;
  let topmostLevel = Number.NEGATIVE_INFINITY;
  document.querySelectorAll<HTMLElement>(DIALOG_SELECTOR).forEach((dialog) => {
    const parsed = Number.parseInt(dialog.style.zIndex, 10);
    const level = Number.isNaN(parsed) ? 0 : parsed;
    if (level >= topmostLevel) {
      topmost = dialog;
      topmostLevel = level;
    }
  });
  return topmost;
}
